<template>
    <div class="handle-box-search preOrder">
       
            <h4 class="nextPre">司机预接下一单</h4>
            <div class="pre-box">
                <div class="squ-box"></div>
                <span class="pre-span">预接下一单功能开关</span>
                <div class="pre-span">
                    <el-switch v-model="submit_data.status" inactive-text="" active-value="1" inactive-value="0"> </el-switch>
                </div>
            </div>
            <!-- <div class="pre-box">
                <div class="squ-box"></div>
                <span class="pre-span">是否允许司机取消</span>
                <div class="pre-span">
                    <el-switch v-model="submit_data.allow_cancel" inactive-text="" active-value="1" inactive-value="0"> </el-switch>
                </div>
            </div> -->
            <!-- <div class="pre-box">
                <div class="squ-box"></div>
                <span class="pre-span">允许司机取消次数</span>
                <div class="pre-span">
                    <el-input v-model="submit_data.allow_cancel_num" placeholder="请输入次数"></el-input>
                </div>
            </div> -->
            <div class="pre-box">
                <div class="squ-box"></div>
                <span class="pre-span">接单条件配置</span>
            </div>
            <div>
                <span class="nextPre">下一单【出发地】距离当前订单【目的地】距离(km)</span>
                <el-input v-model="submit_data.end_start_distance" placeholder="请输入距离" class="input-pre"></el-input>
            </div>
            <div>
                <span class="nextPre">司机【当前位置】距离当前订单【目的地】距离(km)</span>
                <el-input v-model="submit_data.this_finish_distance" placeholder="请输入距离" class="input-pre"></el-input>
            </div>
            <div class="pre-box">
                <div class="squ-box"></div>
                <span class="pre-span">接单司机配置</span>
            </div>

            <div class="pre-box">
                <span class="pre-span">允许接单的司机类型</span>
                <el-select class="pre-span" v-model="submit_data.driver_type" placeholder="请选择司机类型" clearable>
                    <el-option label="兼职" value="0"> </el-option>
                    <el-option label="全职" value="1"> </el-option>
                    <el-option label="按单" value="2"> </el-option>
                    <el-option label="全部" value="4"> </el-option>
                </el-select>
            </div>
       
        <!-- 对话框底部按钮 -->

        <div style="display: flex; justify-content: center">
            <el-button type="primary" @click="onSubmitDig">保存</el-button>
        </div>
    </div>
</template>
<script>
var _this;
export default {
    data() {
        return {
            submit_url: '/conf/editPreOrderConf',
            submit_data: {
                status: 0,
                this_finish_distance: '',
                end_start_distance: '',
                allow_cancel: '',
                allow_cancel_num: '',
                driver_type: '4'
            },
            submit_rules: {
                end_start_distance: {
                    placeholder: '下一单出发地距离当前订单目的地距离',
                    rules: {
                        required: true,
                        message: '下一单出发地距离当前订单目的地距离为大于0的数字',
                        regulation: 'number',
                        rulesData: 1
                    }
                },
                this_finish_distance: {
                    placeholder: '司机当前位置距离目的地距离',
                    rules: {
                        required: true,
                        message: '司机当前位置距离目的地距离为大于0的数字',
                        regulation: 'number',
                        rulesData: 1
                    }
                },
                // allow_cancel_num: {
                //     placeholder: '允许司机取消次数',
                //     rules: {
                //         required: true,
                //         message: '允许司机取消次数为大于等于0的数字',
                //         regulation: 'number',
                //         rulesData: 0
                //     }
                // },
                driver_type: {
                    placeholder: '司机类型',
                    rules: {
                        required: true,
                        message: '司机类型',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.getPreOrderConf();
    },
    methods: {
        onSubmitDig() {
            _this.$post(_this.submit_url, _this.submit_data, _this.submit_rules).then((res) => {
                _this.$message.success('保存成功');

                _this.getPreOrderConf();
            });
        },

        getPreOrderConf() {
            console.log(222);
            _this.$post('/conf/getPreOrderConf').then((res) => {
                _this.submit_data.status = res.data.status.val;
                _this.submit_data.this_finish_distance = res.data.this_finish_distance;
                _this.submit_data.end_start_distance = res.data.end_start_distance;
                _this.submit_data.allow_cancel = res.data.allow_cancel;
                _this.submit_data.allow_cancel_num = res.data.allow_cancel_num;
                _this.submit_data.driver_type = res.data.driver_type.val;
            });
        }
    }
};
</script>
<style scoped>
.handle-box-search {
    background-color: #fff !important;
}
.pre-box {
    display: flex;
    justify-content: start;
    margin-top: 10px;
    align-items: center;
   
}
.squ-box {
    background-color: #409eff;
    display: inline-block;
    width: 10px;
    height: 20px;
}
.pre-span {
    margin-left: 10px;
}
.input-pre {
    max-width: 160px !important;
    width: 60% !important;
    margin-left: 10px;
}
.nextPre {
    margin-left: 20px;
}
</style>